import { render, staticRenderFns } from "./UploadBlock.vue?vue&type=template&id=928928ba&scoped=true"
import script from "./UploadBlock.vue?vue&type=script&lang=ts"
export * from "./UploadBlock.vue?vue&type=script&lang=ts"
import style0 from "./UploadBlock.vue?vue&type=style&index=0&id=928928ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928928ba",
  null
  
)

export default component.exports